export const mizrahiTefhotBranches = [
	{
		"region": "מרחב דן",
		"name": "מרכז עסקים בני ברק",
		"number": "76"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות את חולון",
		"number": "19"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות בר אילן",
		"number": "14"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות גבעת שמואל",
		"number": "130"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות גבעתיים",
		"number": "55"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות הנשיאים",
		"number": "81"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות כהנמן",
		"number": "170"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות כפר גנים",
		"number": "148"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות מגדלי קונקורד",
		"number": "115"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות מע פתח תקווה",
		"number": "29"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות מרום נווה",
		"number": "134"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות קריית אונו",
		"number": "67"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות קריית אריה",
		"number": "119"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות ראש העין",
		"number": "143"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות רמת-גן",
		"number": "13"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות רמת סיב",
		"number": "31"
	},
	{
		"region": "מרחב דן",
		"name": "נציגות תל-השומר יהב",
		"number": "150/734646"
	},
	{
		"region": "מרחב דן",
		"name": "סניף בני ברק",
		"number": "183"
	},
	{
		"region": "מרחב דן",
		"name": "סניף חזון איש בני ברק",
		"number": "68"
	},
	{
		"region": "מרחב דן",
		"name": "סניף לב העיר פתח תקווה",
		"number": "150"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות אופקים",
		"number": "37"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות את ראשלץ",
		"number": "95"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות באר שבע - יהב",
		"number": "26/734648"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות ברנע",
		"number": "90"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות דימונה",
		"number": "56"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות הבאר",
		"number": "129"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות יבנה",
		"number": "140"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות מ.ע אשדוד",
		"number": "16"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות מ.ע. באר שבע",
		"number": "26"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות נס ציונה",
		"number": "111"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות נתיבות",
		"number": "28"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות ערד",
		"number": "89"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות פארק המדע",
		"number": "132"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות קרית מלאכי",
		"number": "50"
	},
	{
		"region": "מרחב דרום",
		"name": "נציגות ראשלץ - יהב",
		"number": "26/734648"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף אשדוד סיטי",
		"number": "165"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף אשקלון",
		"number": "27"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף את אשדוד",
		"number": "215"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף באר שבע",
		"number": "166"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף קקל",
		"number": "144"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף קרית גת",
		"number": "33"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף ראשון לציון",
		"number": "35"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף רחובות",
		"number": "34"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף שדרות",
		"number": "84"
	},
	{
		"region": "מרחב דרום",
		"name": "סניף שלוחת רחובות",
		"number": "257"
	},
	{
		"region": "מרחב המרכז",
		"name": "בלפור בת ים",
		"number": "154"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות איכילוב - יהב",
		"number": "94/734658"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות בת ים",
		"number": "25"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות גן העיר",
		"number": "21"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות הארבעה - יהב",
		"number": "94/734658"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות המגדל",
		"number": "77"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות וולפסון - יהב",
		"number": "94/734658"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות חצרות יפו",
		"number": "36"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות יגאל אלון",
		"number": "157"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות כיכר המדינה",
		"number": "10"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות לב דיזינגוף",
		"number": "53"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות מ.ע. יהלומים",
		"number": "66"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות מ.ע. תל אביב",
		"number": "61"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות סוקולוב חולון",
		"number": "12"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות סלמה",
		"number": "69"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות עתידים",
		"number": "128"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות קרית איילון",
		"number": "11"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות ריבל",
		"number": "8"
	},
	{
		"region": "מרחב המרכז",
		"name": "נציגות רמת אביב",
		"number": "93"
	},
	{
		"region": "מרחב המרכז",
		"name": "סניף חולון",
		"number": "155"
	},
	{
		"region": "מרחב המרכז",
		"name": "סניף פז רמת גן",
		"number": "151"
	},
	{
		"region": "מרחב המרכז",
		"name": "סניף תל-אביב",
		"number": "156"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות את כפר סבא",
		"number": "24"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות הוד השרון",
		"number": "112"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות הרצליה פיתוח",
		"number": "122"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות זכרון יעקב",
		"number": "590"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות חדרה יהב",
		"number": "122/734645"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות חריש",
		"number": "0"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות סוהו מ.ע נתניה",
		"number": "22"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות פרדס חנה",
		"number": "73"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות קרני שומרון",
		"number": "83"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות רמת השרון",
		"number": "72"
	},
	{
		"region": "מרחב השרון",
		"name": "נציגות רעננה",
		"number": "23"
	},
	{
		"region": "מרחב השרון",
		"name": "סניף הרצליה",
		"number": "15"
	},
	{
		"region": "מרחב השרון",
		"name": "סניף חדרה",
		"number": "20"
	},
	{
		"region": "מרחב השרון",
		"name": "סניף כפר סבא",
		"number": "247"
	},
	{
		"region": "מרחב השרון",
		"name": "סניף ערים",
		"number": "126"
	},
	{
		"region": "מרחב השרון",
		"name": "סניף קניון אורות",
		"number": "38"
	},
	{
		"region": "מרחב השרון",
		"name": "סניף קניון השרון",
		"number": "669"
	},
	{
		"region": "מרחב השרון",
		"name": "סניף קרית אתגרים",
		"number": "161"
	},
	{
		"region": "מרחב יהודה",
		"name": "מרכז עסקים ירושלים",
		"number": "168"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות אגריפס",
		"number": "191"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות אור יהודה",
		"number": "592"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות אלון שבות",
		"number": "54"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות בית יהב",
		"number": "423"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות בן יהודה",
		"number": "1"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות גבעת שאול",
		"number": "58"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות הלל - ים - יהב",
		"number": "436"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות העיר העתיקה",
		"number": "59"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות יהוד",
		"number": "114"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות כנפי נשרים",
		"number": "139"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות לוד מטל",
		"number": "146"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות מעלה אדומים יהב",
		"number": "465"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות נתבג",
		"number": "18"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות נתבג - יהב",
		"number": "861"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות סביונים",
		"number": "125"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות עין כרם - יהב",
		"number": "862"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות פסגת זאב יהב",
		"number": "461"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות קניון מלחה - יהב",
		"number": "863"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות רמלה",
		"number": "32"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות שערי צדק",
		"number": "79"
	},
	{
		"region": "מרחב יהודה",
		"name": "נציגות תלפיות",
		"number": "117"
	},
	{
		"region": "מרחב יהודה",
		"name": "סניף אילת",
		"number": "70"
	},
	{
		"region": "מרחב יהודה",
		"name": "סניף בית-שמש",
		"number": "167"
	},
	{
		"region": "מרחב יהודה",
		"name": "סניף גאולה",
		"number": "17"
	},
	{
		"region": "מרחב יהודה",
		"name": "סניף מודיעין",
		"number": "121"
	},
	{
		"region": "מרחב יהודה",
		"name": "סניף רמות",
		"number": "163"
	},
	{
		"region": "מרחב יהודה",
		"name": "סניף רמת אשכול",
		"number": "169"
	},
	{
		"region": "מרחב צפון",
		"name": "מרכז עסקים חיפה",
		"number": "164"
	},
	{
		"region": "מרחב צפון",
		"name": "מתם חיפה",
		"number": "105"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות בית שאן",
		"number": "39"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות הדר חיפה",
		"number": "41"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות חיפה - יהב",
		"number": "44/734646"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות יקנעם",
		"number": "182"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות כרמל",
		"number": "49"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות נווה-שאנן",
		"number": "92"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות נשר",
		"number": "123"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות קריית-אתא",
		"number": "48"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות קרית שמונה",
		"number": "87"
	},
	{
		"region": "מרחב צפון",
		"name": "נציגות שלומי",
		"number": "42"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף טבריה",
		"number": "62"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף כרמיאל",
		"number": "113"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף מגדל העמק",
		"number": "152"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף מעלות",
		"number": "158"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף נהריה",
		"number": "43"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף נוף הגליל(נ. עלית)",
		"number": "160"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף נצרת",
		"number": "159"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף עכו",
		"number": "45"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף עפולה",
		"number": "74"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף צפת",
		"number": "162"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף קרית ביאליק",
		"number": "118"
	},
	{
		"region": "מרחב צפון",
		"name": "סניף קרית ים",
		"number": "46"
	}
]


// WEBPACK FOOTER //
// ./src/app/mizrahi tefaho branchs.ts